import * as React from "react"
import { connect } from "react-redux"
import { Button, Icon, Popup } from "semantic-ui-react"
import { DropitState, getTranslationsByScopes } from "../../../core/reducers"
import { FieldType, ITranslations } from "../../../models"

interface IButtonChangeProps {
  code: string
  modified: boolean
  classes?: IClasseNames
  fieldType: FieldType
  onClick: (e: any, fieldType: FieldType) => void
}

interface IClasseNames {
  modified: string
  unModified: string
}

const ButtonChange = (
  props: IButtonChangeProps & { translations: ITranslations["multiModif"] }
) => {
  const { modified, onClick, code, classes, fieldType } = props
  const usedClasses = classes || {
    modified: "modified",
    unModified: "unModified",
  }

  const onClickLock = (e: any) => {
    onClick(e, fieldType)
  }

  return (
    <Popup
      disabled={!modified}
      content={props.translations.cancelChange}
      position="top center"
      trigger={
        <Button
          name={code}
          className={
            (modified ? usedClasses.modified : usedClasses.unModified) +
            " " +
            "change-button"
          }
          color="black"
          value={modified}
          onClick={onClickLock}
          type="button"
        >
          <Icon name={modified ? "eraser" : "edit"} className="modified-icon" />
        </Button>
      }
    />
  )
}

export const ButtonChangeSampleOff = () => {
  return (
    <Button
      name={""}
      className={"unModified change-button"}
      color="black"
      type="button"
    >
      <Icon name={"edit"} className="modified-icon" />
    </Button>
  )
}

export const ButtonChangeSampleOn = () => {
  return (
    <Button
      name={""}
      className={"modified change-button"}
      color="black"
      type="button"
    >
      <Icon name={"eraser"} className="modified-icon" />
    </Button>
  )
}

const mapStateToProps = (state: DropitState, props: IButtonChangeProps) => ({
  translations: getTranslationsByScopes(state, ["multiModif"]),
  ...props,
})

export default connect<IButtonChangeProps, any, any, DropitState>(
  mapStateToProps
)(ButtonChange)
